import { __assign, __rest } from "tslib";
import React from 'react';
import CommentBoxAvatar from '../../../../lego/CommentBoxAvatar';
import CommentBoxEditor from '../../../../lego/CommentBoxEditor';
import CommentBoxLayout from '../../../../layouts/CommentBoxLayout';
var EditorView = function (_a) {
    var rest = __rest(_a, []);
    return (React.createElement(CommentBoxLayout, { avatar: React.createElement(CommentBoxAvatar, null), content: React.createElement(CommentBoxEditor, __assign({}, rest)) }));
};
EditorView.displayName = 'EditorView';
export default EditorView;
//# sourceMappingURL=EditorView.js.map